//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from 'quasar'
import { required } from 'vuelidate/lib/validators'
// 解构只保留需要的东西
const { addToDate } = date
const stringCompanys = [
  { label: '贝克巴斯', value: 'BKBS' },
  { label: '思维思通', value: '3M' },
  { label: '亿瞳', value: '亿瞳' }
]
const conTfOptions = [
  { label: '不显示', value: '0' },
  { label: '显示', value: '1' }
]
const conDelOptions = [
  { label: '正常', value: '0' },
  { label: '删除', value: '1' }
]
export default {
  components: {
    date, required
  },
  data() {
    return {
      form: {
        enId: '',
        name: '',
        company:'',
        company_name:'',
        tplus_number:'',
        manager:'',
        is_del:'',
        use_in_400:'',
        contact_user:'',
        contact_user_mobile:'',
        contact_user_position:'',
        company_phone:'',
        userProvince:'',
        userCity:'',
        userArea:'',
        address:''
      },
      companyOptions: stringCompanys,
      useIn400Options:conTfOptions,
      isDelOptions:conDelOptions,
      title:'添加渠道',
      loading4: false,
      provinceId: 0,
      cityId: 0,
      areaId: 0,
      text: null,
      provinceOptions: [],
      provinceAllData: [],
      cityOptions: [],
      cityAllData: [],
      areaOptions: [],
      areaAllData: [],
    }
  },
  validations: {
    form: {
      name: { required }
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    let enId = this.$route.params.enId
    let title = '添加渠道';
    if(enId!='0'){
      title = '编辑渠道';
      this.$axios
      .get('/api/admin/channel/info?from=quasar&enId='+enId)
      .then(res => {
        let resData = res.data.data
        let form = {
          enId: enId,
          name: resData['simple_name'],
          company_name:resData['company_name'],
          tplus_number:resData['tplus_number'],
          manager:resData['manager'],
          contact_user:resData['channelInfo']['contact_user'],
          contact_user_mobile:resData['channelInfo']['contact_user_mobile'],
          contact_user_position:resData['channelInfo']['contact_user_position'],
          company_phone:resData['channelInfo']['company_phone'],
          address:resData['channelInfo']['address']
        }
        form.is_del = {
            label:resData['isDel'],
            value:resData['is_del']
        }
        form.use_in_400 = {
            label:resData['useIn400'],
            value:resData['use_in_400']
        }
        form.company = {
            label:resData['company'],
            value:resData['company']
        }
        if(resData['channelInfo']['provinceName']!=''){
          let channelInfo = resData['channelInfo'];
          let province = {
            label:channelInfo['provinceName'],
            value:channelInfo['province_id']
          }
          form.userProvince = province
          that.onProvinceChange(province)
          let city = {
            label:channelInfo['cityName'],
            value:channelInfo['city_id']
          }
          form.userCity = city;
          that.onCityChange(city)
          let area = {
            label:channelInfo['areaName'],
            value:channelInfo['area_id']
          }
          form.userArea = area
        }
        that.form = form
        console.log(resData)
      })
      .catch(function (error) { // 请求失败处理
        console.log(error);
      });
    }
   
    this.title = title

    //省份
    this.$axios
      .get('/api/city/info?from=quasar')
      .then((response) => (this.provinceAllData = this.provinceOptions = this.newProvinceOptions = response.data.data))
      .catch(function (error) { // 请求失败处理
        console.log(error);
      });
  },
  methods: {
    filterProvince(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.provinceOptions = this.provinceAllData.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
      })
    },
    onProvinceChange(val) {
      console.log("onProvinceChange", val.label, val.value);
      this.form.userCity = null;
      this.cityAllData = [];
      this.cityOptions = [];
      this.form.userArea = null;
      this.areaAllData = [];
      this.areaOptions = [];
      this.$axios
        .get('/api/city/info?from=quasar&pid=' + val.value)
        .then((response) => (this.cityAllData = this.cityOptions = response.data.data))
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    filterCity(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.cityOptions = this.cityAllData.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
      })
    },
    onCityChange(val) {
      this.form.userArea = null;
      this.areaAllData = [];
      this.areaOptions = [];
      this.$axios
        .get('/api/city/info?from=quasar&pid=' + val.value)
        .then((response) => (this.areaAllData = this.areaOptions = response.data.data))
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    filterArea(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.areaOptions = this.areaAllData.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
      })
    },
    simulateProgress(number) {
      console.log('submit')
      console.log(this.form);
      this.$v.form.$touch()
      if (this.$v.form.$error) {
        this.$q.notify('请检查资料是否输入完整')
        return
      }
      var that = this;
      // we set loading state
      this[`loading${number}`] = true
      var data = this.form;
      let type = this.$route.params.type
      if(type==5){
        data.orders=[]
      }

      this.$axios({
        url: '/api/admin/channel/edit?from=quasar',
        method: 'post',
        data: JSON.stringify(data),
        header: {
          'Content-Type': 'application/json'  //如果写成contentType会报错
        }
      })
        .then(res => {
          console.log(res.data)
          this[`loading${number}`] = false
          if (res.data.status == 0) {
            that.showSuccess()
            this.$router.push('/channel')
          }else{
            that.showError(res.data.errmsg)
          }
        })
        .catch(Error => {
          console.log(Error)
          this[`loading${number}`] = false
        })

    },
    dispatchDateOptionFun(d) {
      let newDate = addToDate(new Date(), { days: 1 })
      let startDate = date.formatDate(newDate, 'YYYY/MM/DD')
      return d > startDate
    },
    showSuccess() {
      this.$q.notify({
        message: '提示',
        caption: '操作成功',
        color: 'secondary'
      })
    },
    showError(msg) {
      this.$q.dialog({
        title: '出错了',
        message: msg
      }).onOk(() => {
        // console.log('OK')
      }).onCancel(() => {
        // console.log('Cancel')
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    }
  }
}
